import { Link } from '@remix-run/react'
import { cn } from '#app/shared/lib/misc.js'
import { Icon } from '#app/shared/ui/icons/Icon.js'
import { Button } from '#app/shared/ui/inputs/button/Button.js'

type Props = {
  text?: string
  className?: string
}

export default function ChevronRightButton({
  text = 'Ver todos',
  className,
}: Props) {
  return (
    <Link to="/nuestros-coches">
      <Button
        className={cn(
          `
            group flex h-9 w-[124px] items-center gap-[15px] !border-0 !bg-white
            pl-4 pr-0

            hover:!border-0
          `,
          className,
        )}
      >
        <span
          className={`
            whitespace-nowrap text-nowrap text-subtitle1-bold text-neutral-900
          `}
        >
          {text}
        </span>
        <div
          className={`
            flex h-[32px] min-h-8 w-[32px] min-w-8 items-center justify-center
            bg-neutral-50

            group-hover:bg-primary
          `}
        >
          <Icon name="basic/chevron-right" size="12px" color="black" />
        </div>
      </Button>
    </Link>
  )
}
